import axios from '@/utils/axios'
// 组件列表
export function list(query) {
    return axios({
        url: '/stat/statVideo/getStatVideoList',
        method: 'get',
        params: query
    })
}
//剧分析
export function analyse(query) {
    return axios({
        url: '/stat/statVideo/getStatVideoEpList',
        method: 'get',
        params: query
    })
}
